import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-field-card',
  imports: [FlexLayoutModule, MatButtonModule, MatIconModule, TranslateModule],
  templateUrl: './field-card.component.html',
  styleUrl: './field-card.component.scss',
})
export class FieldCardComponent {}
